import login from "./login";
import accountInfo from "./account-info";
import home from "./home";
import customers from "./customers";
import funds from "./funds";
import notice from "./notice";
import account from "./account";
import activity from "./activity";
import oldbeltnew from "./oldbeltnew";
import dollarGift from "./dollarGift";
import integration from "./integration";
import email from "./email";
import digital from "./digital";

export {
  login,
  accountInfo,
  home,
  customers,
  funds,
  notice,
  account,
  activity,
  oldbeltnew,
  dollarGift,
  integration,
  email,
  digital
};



// WEBPACK FOOTER //
// ./src/api/index.js